var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bax-section bax-select-patient-wrap"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"bax-bg bax-bg-foot-link bax-create-patient"},[_c('div',[_vm._v(" Processing your file, please wait. "),_c('img',{staticClass:"loading_animation",attrs:{"src":require("@/assets/images/loading.gif"),"alt":"Loading"}})])])])])
}]

export { render, staticRenderFns }